import { Avatar, Box, Tab, Tabs, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { useEffect, useState } from "react";
import { userType } from "../../../utils/Constant";
import { getCurrentClientDetailsRequest } from "../../../redux/clients/slice";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import Loading from "../../../components/loading/loading";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ClientDetails from "./client/details/details";
import { getCurrentInspectionFirmDetailsRequest } from "../../../redux/inspection-firms/slice";
import InspectionFirmDetails from "./inspection-firm/details/details";
import TaxDetails from "./inspection-firm/tax-details/tax-details";
import Insurance from "./inspection-firm/insurance/insurance";
import Services from "./inspection-firm/services/services";
import CoverageArea from "./inspection-firm/coverage-area/coverage-area";
import Users from "./inspection-firm/users/users";
import InspectionFirmOrders from "../inspection-firms/inspection-firm-details/orders/orders";
import { useLocation, useNavigate } from "react-router-dom";
import ClientDivisions from "./client/client-division/client-divisions";
import ClientInvoices from "../clients/client-details/invoices/invoices";
import ClientResults from "../clients/client-details/results/results";
import CurrentProcessesProcedures from "./client/processes-procedures/processes-procedures";
import Forms from "./client/forms/forms";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function TabLabel(data: any) {
  return (
    <>
      {data?.label}
      {data?.showWarning && (
        <InfoOutlinedIcon className="tab-label-warning-icon" />
      )}
    </>
  );
}

export default function MyOrganization() {
  const dispatch = useDispatch();
  const { state, pathname } = useLocation();
  const navigate = useNavigate();
  const [isClientUser, setIsClientUser] = useState(false);
  const [value, setValue] = useState(0);
  const { currentUser } = useSelector((state: any) => state.user.user);
  const { loading, currentClientDetails } = useSelector(
    (state: any) => state.clients
  );
  const { loading: inspectionFirmLoading, currentInspectionFirmDetails } =
    useSelector((state: any) => state.inspectionFirms);

  useEffect(() => {
    if (currentUser) {
      if (currentUser?.userType === userType?.client) {
        setIsClientUser(true);
        dispatch(getCurrentClientDetailsRequest());
      } else {
        setIsClientUser(false);
        dispatch(getCurrentInspectionFirmDetailsRequest());
      }
    }
  }, [currentUser]); // eslint-disable-line

  useEffect(() => {
    if (pathname.includes("/users") && !pathname.includes("/users/")) {
      setValue(currentUser?.userType === userType?.client ? 2 : 5);
    } else if (pathname.includes("/users/")) {
      setValue(currentUser?.userType === userType?.client ? 2 : 5);
    }
  }, [pathname]); // eslint-disable-line

  useEffect(() => {
    if (pathname.includes("/users") && !pathname.includes("/users/")) {
      if (!state?.breadcrumb?.names) {
        navigate(pathname, {
          state: {
            ...state,
          },
          replace: true,
        });
      }
    }
  }, [pathname, navigate]); // eslint-disable-line

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (currentUser?.userType === userType?.client && newValue !== 2) {
      const newPath = pathname.replace("/users", "");
      navigate(newPath, {
        replace: true,
        state: {
          breadcrumb: {
            names: {
              [currentClientDetails?.id]: currentClientDetails?.clientName,
            },
          },
        },
      });
    }
    if (currentUser?.userType === userType?.inspector && newValue !== 5) {
      const newPath = pathname.replace("/users", "");
      navigate(newPath, {
        replace: true,
        state: {
          breadcrumb: {
            names: {
              [currentInspectionFirmDetails?.id]:
                currentInspectionFirmDetails?.clientName,
            },
          },
        },
      });
    }
  };

  return (
    <>
      {currentUser?.userType !== userType.client && <ContactSpectrum />}
      <Box mt={currentUser?.userType === userType.client ? 2 : 0}>
        <Breadcrumb />
      </Box>
      <Box className="user-info-layout">
        {isClientUser ? (
          <>
            <Box className="avatar-container">
              <Avatar
                className="user-avatar"
                alt={currentClientDetails?.clientName}
                variant="circular"
                src={currentClientDetails?.logoUrl}
              />
            </Box>
            <Box className="margin-left" sx={{ mt: 1 }}>
              <Typography variant="h4">
                {currentClientDetails?.clientName}
              </Typography>
              {currentClientDetails?.mailingAddress && (
                <Box className="user-details-content user-location-content">
                  <LocationOnOutlinedIcon className="user-location-icon" />
                  <Typography className="user-location-txt">
                    {currentClientDetails?.mailingAddress?.city},{" "}
                    {currentClientDetails?.mailingAddress?.state}
                  </Typography>
                </Box>
              )}
            </Box>
          </>
        ) : (
          <>
            <Box className="avatar-container">
              <Avatar
                className="user-avatar"
                alt={currentInspectionFirmDetails?.clientName}
                variant="circular"
                src={currentInspectionFirmDetails?.logoUrl}
              />
            </Box>
            <Box className="margin-left" sx={{ mt: 1 }}>
              <Typography variant="h4">
                {currentInspectionFirmDetails?.displayName}
              </Typography>
              {currentInspectionFirmDetails?.mailingAddress && (
                <Box className="user-details-content user-location-content">
                  <LocationOnOutlinedIcon className="user-location-icon" />
                  <Typography className="user-location-txt">
                    {currentInspectionFirmDetails?.mailingAddress?.city},{" "}
                    {currentInspectionFirmDetails?.mailingAddress?.state}
                  </Typography>
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          px: 2,
          py: 1.5,
          backgroundColor: "#E5F6FD",
          mx: 1.5,
          borderRadius: 0.5,
          mt: 3,
        }}
      >
        <InfoOutlinedIcon sx={{ color: "#0288D1", height: 22, width: 22 }} />
        <Box sx={{ ml: 1 }}>
          <Typography sx={{ color: "#014361" }}>
            <b>Read-Only Details</b>
          </Typography>
          <Typography sx={{ fontSize: 14, color: "#014361", mt: 0.5 }}>
            Some information in this section is read-only. Contact your Spectrum
            relationship manager to make edits.
          </Typography>
        </Box>
      </Box>

      <Box className="tab-header" mx={2}>
        {isClientUser ? (
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="user details tabs"
            variant="scrollable"
            scrollButtons={false}
          >
            <Tab
              className="tab-label"
              label={<TabLabel label="Details" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Client Divisions" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Users" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Invoices" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Results" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Forms" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={
                <TabLabel label="Processes & Procedures" showWarning={false} />
              }
            />
          </Tabs>
        ) : (
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="user details tabs"
            variant="scrollable"
            scrollButtons={false}
          >
            <Tab
              className="tab-label"
              label={<TabLabel label="Company Details" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Tax" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Insurance" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Service Offered" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Coverage Area" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Users" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Orders" showWarning={false} />}
            />
          </Tabs>
        )}
      </Box>

      {isClientUser ? (
        <>
          <CustomTabPanel value={value} index={0}>
            <ClientDetails data={currentClientDetails} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <ClientDivisions />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Users />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <ClientInvoices />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <ClientResults clientDetails={currentClientDetails} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
            <Forms />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={6}>
            <CurrentProcessesProcedures />
          </CustomTabPanel>
        </>
      ) : (
        <>
          <CustomTabPanel value={value} index={0}>
            <InspectionFirmDetails data={currentInspectionFirmDetails} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <TaxDetails />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Insurance />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Services />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <CoverageArea />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
            <Users />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={6}>
            <InspectionFirmOrders
              data={currentInspectionFirmDetails}
              isMyOrganisation={true}
            />
          </CustomTabPanel>
        </>
      )}

      {(loading || inspectionFirmLoading) && <Loading />}
    </>
  );
}
